import { render, staticRenderFns } from "./editMail.vue?vue&type=template&id=5ef43b48&scoped=true"
import script from "./editMail.vue?vue&type=script&lang=js"
export * from "./editMail.vue?vue&type=script&lang=js"
import style0 from "./editMail.vue?vue&type=style&index=0&id=5ef43b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef43b48",
  null
  
)

export default component.exports